import { observable, action } from 'mobx';
import { GoalsApi } from '../../../../apis/goals';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { MonthlyGoalIndex, MonthlyGoal, LongTermGoal } from '../../../../types/goals';

function dateToMonthlyGoalIndex(date) {
    return { year: date.getFullYear(), month: date.getMonth() + 1 };
}

export class GoalsPaneState {
    @observable year: number;
    @observable month: number;
    @observable monthlyGoals: RemoteResourceV3<MonthlyGoalIndex[]> = RemoteResourceV3.loading();
    @observable monthlyGoal: RemoteResourceV3<MonthlyGoal> = RemoteResourceV3.loading();
    @observable longTermGoal: RemoteResourceV3<LongTermGoal> = RemoteResourceV3.loading();
    @observable firstMonth: MonthlyGoalIndex;
    @observable lastMonth: MonthlyGoalIndex;
    @observable today = new Date();
    @observable showIdealCareerModal = false;
    @observable showYearlyGoalModal = false;

    async init() {
        this.year = this.today.getFullYear();
        this.month = this.today.getMonth() + 1;
        await this.loadMonthlyGoal();
        await this.loadLongTermGoal();

        const monthlyGoals = await updateRemoteResourceV3(
            this.monthlyGoals,
            (v) => (this.monthlyGoals = v),
            () => GoalsApi.findAllMonthlyGoals()
        );
        monthlyGoals.push(dateToMonthlyGoalIndex(this.today));
        const nextMonth = new Date(this.today);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        monthlyGoals.push(dateToMonthlyGoalIndex(nextMonth));
        monthlyGoals.push({
            year: this.today.getFullYear() + (this.today.getMonth() == 11 ? 1 : 0),
            month: this.today.getMonth() == 11 ? 1 : this.today.getMonth() + 2,
        });
        monthlyGoals.sort((a, b) => a.year * 12 + a.month - b.year * 12 - b.month);
        this.firstMonth = monthlyGoals[0];
        this.lastMonth = monthlyGoals[monthlyGoals.length - 1];
    }

    @action.bound
    async loadMonthlyGoal() {
        updateRemoteResourceV3(
            this.monthlyGoal,
            (v) => (this.monthlyGoal = v),
            () => GoalsApi.findMonthlyGoal(this.year, this.month)
        );
    }

    @action.bound
    async loadLongTermGoal() {
        updateRemoteResourceV3(this.longTermGoal, (v) => (this.longTermGoal = v), () => GoalsApi.findLongTermGoal());
    }

    @action.bound
    async selectMonth(year, month) {
        this.year = year;
        this.month = month;
        this.loadMonthlyGoal();
    }

    @action.bound
    async selectPreviousMonth() {
        const nextYear = this.month === 1 ? this.year - 1 : this.year;
        const nextMonth = this.month === 1 ? 12 : this.month - 1;
        this.selectMonth(nextYear, nextMonth);
    }

    @action.bound
    async selectNextMonth() {
        const nextYear = this.month === 12 ? this.year + 1 : this.year;
        const nextMonth = this.month === 12 ? 1 : this.month + 1;
        this.selectMonth(nextYear, nextMonth);
    }

    monthText(year = this.year, month = this.month) {
        let text = '';
        if (this.today.getFullYear() !== year) {
            text += `${year}年`;
        }
        text += `${month}月`;
        return text;
    }

    @action.bound
    async openIdealCareerModal() {
        this.showIdealCareerModal = true;
    }

    @action.bound
    async closeIdealCareerModal() {
        this.showIdealCareerModal = false;
        this.loadLongTermGoal();
    }

    @action.bound
    async openYearlyGoalModal() {
        this.showYearlyGoalModal = true;
    }

    @action.bound
    async closeYearlyGoalModal() {
        this.showYearlyGoalModal = false;
        this.loadLongTermGoal();
    }
}
